var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipment(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 47,
    viewBox: "0 0 56 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.578 21.082L23.617-.01.364 14.896v9.418a.871.871 0 00.372.709L31.93 46.846a.85.85 0 001 0l22.334-15.614a.872.872 0 00.372-.721v-9.43h-.058zM32.325 35.464L26 30.964l9.371-6.65 6.325 4.5-9.371 6.65zm-6.418-6.57L24.35 2.573l19.986 13.185-18.428 13.138zm-1.698.803L10.072 19.652l13.033-8.604 1.104 18.649zm18.987-1.953l-6.325-4.5 9.057-6.43 6.546 4.268-9.278 6.662zM22.606 2.712l.383 6.324-14.382 9.488.093.15-5.22-3.708L22.604 2.712zM2.095 16.117l29.45 20.928v7.418L2.096 23.86v-7.743zM33.29 44.463v-7.534l20.59-14.685v7.767L33.29 44.463z",
    fill: "#420022"
  })));
}
export default SvgShipment;